var exports = {
  "IW": "TypingUsers.module__typing___eDBJUW",
  "Xh": "TypingUsers.module__username___eDBJUW",
  "V": "TypingUsers.module__composerStatus___eDBJUW",
  "sM": "TypingUsers.module__srOnly___eDBJUW",
  "xP": "TypingUsers.module__measure___eDBJUW",
};

module.exports = exports;
